<section class="erscheinungsbild__karte" aria-labelledby="erscheinungsbild-branding-titel">
  <to-section-title
    headingId="erscheinungsbild-branding-titel"
    [title]="'erscheinungsbild.brandingTitle' | translate"
    [subtitle]="'erscheinungsbild.brandingSubtitle' | translate"
  />

  <div class="erscheinungsbild__zeile erscheinungsbild__zeile--erste">
    <div>
      <div class="erscheinungsbild__feldtitel">{{ 'erscheinungsbild.colorTitle' | translate }}</div>
      <div class="erscheinungsbild__hinweis">{{ 'erscheinungsbild.colorHint' | translate }}</div>
    </div>
    <div>
      <div class="erscheinungsbild__farbzeile">
        <label class="erscheinungsbild__farbfeld" [title]="'erscheinungsbild.colorPickerAriaLabel' | translate">
          <span class="erscheinungsbild__farbflaeche" [style.background]="vorschauFarbe()"></span>
          <span class="erscheinungsbild__farbbadge" aria-hidden="true">
            <mat-icon class="erscheinungsbild__farbbadge-icon">palette</mat-icon>
          </span>
          <input
            type="color"
            class="erscheinungsbild__farbwaehler"
            [value]="vorschauFarbe().toLowerCase()"
            [attr.aria-label]="'erscheinungsbild.colorPickerAriaLabel' | translate"
            (input)="farbwaehlerGeaendert($event)"
          />
        </label>
        <div class="erscheinungsbild__hex">
          <span class="erscheinungsbild__hex-praefix" aria-hidden="true">HEX</span>
          <input
            class="erscheinungsbild__hex-eingabe"
            [formControl]="form.controls.color"
            [attr.aria-label]="'erscheinungsbild.colorLabel' | translate"
            [attr.aria-invalid]="farbFehler() ? true : null"
            [attr.aria-describedby]="farbFehler() ? 'erscheinungsbild-farbe-fehler' : null"
            (blur)="hexErweitern()"
          />
        </div>
      </div>
      <div
        class="erscheinungsbild__vorschlaege"
        role="group"
        [attr.aria-label]="'erscheinungsbild.colorPresetsLabel' | translate"
      >
        @for (farbe of farbVorschlaege; track farbe) {
          <button
            type="button"
            class="erscheinungsbild__vorschlag"
            [class.erscheinungsbild__vorschlag--gewaehlt]="werte().color === farbe"
            [style.background]="farbe"
            [title]="farbe"
            [attr.aria-label]="('erscheinungsbild.colorPresetAriaLabel' | translate) + ' ' + farbe"
            [attr.aria-pressed]="werte().color === farbe"
            (click)="farbeWaehlen(farbe)"
          ></button>
        }
      </div>
      @if (farbFehler(); as fehler) {
        <p id="erscheinungsbild-farbe-fehler" class="erscheinungsbild__fehler">{{ fehler | translate }}</p>
      }
    </div>
  </div>

  <div class="erscheinungsbild__trenner"></div>

  <div class="erscheinungsbild__zeile">
    <div>
      <div class="erscheinungsbild__feldtitel">{{ 'erscheinungsbild.logoTitle' | translate }}</div>
      <div class="erscheinungsbild__hinweis">{{ 'erscheinungsbild.logoHint' | translate }}</div>
    </div>
    <div>
      <div class="erscheinungsbild__logo">
        <div
          class="erscheinungsbild__vorschau"
          data-testid="erscheinungsbild-logo-vorschau"
          [style.background-color]="vorschauFarbe()"
        >
          <img
            class="erscheinungsbild__vorschau-bild"
            [src]="vorschauLogo()"
            [alt]="'erscheinungsbild.logoPreviewAlt' | translate"
          />
        </div>
        <div class="erscheinungsbild__logo-knoepfe">
          <input
            #logoDatei
            class="erscheinungsbild__logo-datei"
            type="file"
            tabindex="-1"
            aria-hidden="true"
            [accept]="logoAccept"
            (change)="logoGewaehlt($event)"
          />
          <button mat-stroked-button type="button" class="erscheinungsbild__knopf" (click)="logoDatei.click()">
            <mat-icon aria-hidden="true">image</mat-icon>
            {{ 'erscheinungsbild.changeLogo' | translate }}
          </button>
          <button
            mat-stroked-button
            type="button"
            class="erscheinungsbild__knopf erscheinungsbild__knopf--gefahr"
            (click)="loeschenFragen.set(true)"
          >
            <mat-icon aria-hidden="true">delete</mat-icon>
            {{ 'erscheinungsbild.deleteLogo' | translate }}
          </button>
        </div>
        <div class="erscheinungsbild__tipp">
          <strong class="erscheinungsbild__tipp-label">{{ 'erscheinungsbild.logoTipLabel' | translate }}:</strong>
          {{ 'erscheinungsbild.logoTip' | translate }}
        </div>
      </div>
      @if (logoFehler(); as fehler) {
        <p class="erscheinungsbild__fehler" role="alert">{{ fehler | translate }}</p>
      }
    </div>
  </div>

  <div class="erscheinungsbild__trenner"></div>

  <div class="erscheinungsbild__zeile">
    <div>
      <div class="erscheinungsbild__feldtitel">{{ 'erscheinungsbild.nameTitle' | translate }}</div>
      <div class="erscheinungsbild__hinweis">{{ 'erscheinungsbild.nameHint' | translate }}</div>
    </div>
    <div>
      <div class="erscheinungsbild__name">
        <input
          class="erscheinungsbild__name-eingabe"
          [formControl]="form.controls.name"
          [attr.maxlength]="nameMax"
          [attr.aria-label]="'erscheinungsbild.nameLabel' | translate"
          [attr.aria-invalid]="nameFehler() ? true : null"
          [attr.aria-describedby]="nameFehler() ? 'erscheinungsbild-name-fehler' : null"
        />
        <span class="erscheinungsbild__zaehler" aria-live="polite">{{ werte().name.length }} / {{ nameMax }}</span>
      </div>
      @if (nameFehler(); as fehler) {
        <p id="erscheinungsbild-name-fehler" class="erscheinungsbild__fehler">{{ fehler | translate }}</p>
      }
    </div>
  </div>
</section>

<app-vw-ungespeichert [bereich]="this" />

<app-confirm-dialog
  [visible]="loeschenFragen()"
  [title]="'erscheinungsbild.logoDeleteModalTitle' | translate"
  [message]="'erscheinungsbild.logoDeleteModalText' | translate"
  [confirmLabel]="'erscheinungsbild.logoDeleteConfirm' | translate"
  [cancelLabel]="'settings.cancel' | translate"
  icon="delete"
  confirmColor="warn"
  (confirmed)="loeschenBestaetigen()"
  (cancelled)="loeschenFragen.set(false)"
/>
